import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=6074e137&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=6074e137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6074e137",
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QFooter} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QFooter})
